<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/agent/userlist' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加地区</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="role_name">
          <div v-for="(item,index) in row.role_name" :key="index">
            <Tag color="blue" >{{item}}</Tag>
          </div>

        </template>
        <template slot-scope="{ row, index }" slot="avatar">
          <div class="tabBox_img">
            <img :src="row.avatar ? row.avatar : require('@/assets/images/avatar.png')">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="editArea(row)">编辑</a>
          <Divider type="vertical"/>
          <a @click="del(row,'删除')">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <areaEdit ref="areaEdit" :id="userid" @updateStatusModel="updateStatusModel"></areaEdit>
    <!--删除-->
    <modalSure ref="modalSure" title="地区" :id="userid" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { agentAreaList, changeStatus, delArea } from '@/api/agent'
import userEdit from './edit'
import areaEdit from './area'
import modalSure from '@/components/modalSure'
export default {
  name: 'adminUser',
  components: { userEdit, areaEdit, modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        agent_id: 0
      },
      modelApi: delArea,
      dataCount: 0,
      field_key: 'all',
      userInfo: [],
      loading: false,
      userid: 0,
      columns2: [
        {
          title: '代理地区',
          key: 'region',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.userForm.agent_id = this.$route.params.id
    }
    this.userList()
  },
  methods: {
    userList () {
      this.loading = true
      agentAreaList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.userList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.userList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    // 启用禁用用户
    changeSwitch (row) {
      changeStatus(row.id).then(async res => {
        this.$Message.success(res.msg)
        this.userList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    edit (id) {
      this.userid = id
      this.$refs.userEdit.isShow = true
    },
    // 添加
    add () {
      this.$refs.areaEdit.agent.agent_id = this.userForm.agent_id
      this.$refs.areaEdit.isShow = true
    },
    del (row) {
      this.userid = row.agent_area_id
      this.$refs.modalSure.isShow = true
    },
    updateStatusModel () {
      this.reload()
    },
    closeModal (val) {
      this.userList()
    },
    editArea (row) {
      this.userid = row.agent_area_id
      this.$refs.areaEdit.isShow = true
      this.$refs.areaEdit.agent.agent_id = this.userForm.agent_id
    }
  }
}
</script>
